import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    justifyContent: "center",
  },
  confirmButton: {
    backgroundColor: theme.palette.confirmDialog.light,
    "& .MuiButton-label": {
      color: theme.palette.confirmDialog.main,
    },
  },
}));

const ViewDialog = (props) => {
  const { viewDialog, setViewDialog } = props;
  const classes = useStyles();

  return (
    <Dialog open={viewDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogTitle>{viewDialog.viewTitle}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{viewDialog.title}</Typography>
        <img src={viewDialog.imageUrl} height={200} width={200} />
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button onClick={() => setViewDialog({ ...viewDialog, isOpen: false })}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ViewDialog.propTypes = {
  viewDialog: PropTypes.object,
  setViewDialog: PropTypes.func,
};

export default ViewDialog;
